const buildYAxis = (tag: any): Record<string, any> => {
  const axis: Record<string, any> = {
    type: 'linear',
    display: true,
    position: 'left',
    ticks: {
      color: tag?.color,
    },
    grid: {
      drawOnChartArea: false,
    },
  };

  if (!tag?.yAxisAuto && tag?.yAxisFrom != null && tag?.yAxisTo != null) {
    axis.min = tag.yAxisFrom;
    axis.max = tag.yAxisTo;
  }

  return axis;
};

export const generateYAxesWithColors = (tags: any[]) => {
  if (tags.length === 0) return {};

  const yAxes: Record<string, any> = {};
  // eslint-disable-next-line @typescript-eslint/dot-notation
  yAxes['y'] = buildYAxis(tags[0]);

  tags.slice(1).forEach((tag, index) => {
    yAxes[`y${index}`] = buildYAxis(tag);
  });

  return yAxes;
};
